import { useSearchParams } from 'react-router-dom'

export const useGetTypeOfBottleFromUrl = () => {
  const [searchParams] = useSearchParams()
  return searchParams.get('type')
}
